import React from "react";
import PropTypes from "prop-types"
import styled from "styled-components";

const OuterWrapper = styled.div`
`;

const Label = styled.span`
`;

const StyledInput = styled.input`
	border-radius: 2px;
`;

const Input = (props) => {
	const { label, ...rest, } = props;

	return (
		<OuterWrapper>
			{ label && <Label>{ label }</Label> }
			<StyledInput
				{ ...rest }
			/>
		</OuterWrapper>
	);
};

Input.propTypes = {
	flavor: PropTypes.oneOf([
		"BLACK",
		"WHITE",
		"TRANSPARENT",
	]),
	fullWidth: PropTypes.bool,
	label: PropTypes.string,
	message: PropTypes.string,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	type: PropTypes.oneOf([
		"EMAIL",
		"PASSWORD",
		"TEXT",
	]),
	valid: PropTypes.bool,
	value: PropTypes.string,
};

export default Input;
